<template>
  <div class="recipesadd ">
    <div class="top">
      <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
      <el-button type="primary" size="medium" @click="insertDietCommons('ruleForm')">保存</el-button>
    </div>
    <div class="subject" :style="`height: ${windowHeight-180}px;`">
      <div class="body">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
          <el-form-item label="名称" prop="dietName">
            <el-input v-model="ruleForm.dietName" :maxlength="10" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="dietType">
            <el-select v-model="ruleForm.dietType" placeholder="请选择类型">
              <el-option :value="item.id" :label="item.value" v-for="item in foodTypeList" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图片" class="pic">
            <uploader :multiple="false" v-model="piclist" :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                      showMode="cover" :showModeCover="true" showResult="image"></uploader>
            <div class="img-b-box">点击更换图片</div>
          </el-form-item>
          <el-form-item label="描述" prop="dietDes">
            <el-input type="textarea" v-model="ruleForm.dietDes" :maxlength="100"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
  import {insertDietCommon} from "@/api/foodSetting";
  import mixin from "@/mixins/windowResize";
  import Uploader from "@/components/Uploader/WebUploader";

  export default {
    components: {Uploader},
    data() {
      return {
        ruleForm: {
          dietDes: "", //	菜品描述	string
          dietLogo: "", //	菜品图片	string
          dietName: "", //	菜品名	string
          dietType: 1, //	菜品类型,写在配置里HashMap<int,String>	number
        },
        rules: {
          dietName: [
            {required: true, message: "请输入名称", trigger: "blur"},
          ],
          dietType: [
            {required: true, message: "请选择类型", trigger: "change"}
          ],
          dietDes: [
            {required: true, message: "请输入描述", trigger: "blur"}
          ]
        },
        foodTypeList: [{id: 1, value: '大荤'}, {id: 2, value: '小荤'}, {id: 3, value: '素菜'}, {id: 4, value: '汤'}, {
          id: 5,
          value: '水果'
        }, {id: 6, value: '酸奶'}, {id: 7, value: '杂粮'}, {id: 8, value: '粥'}, {id: 9, value: '主食'}],
        piclist: [
          {
            fileUrl:
              "https://cdnfile-10043692.file.myqcloud.com/admin/images/shanshi/shiwu.png",
            fileName: "shiwu.png"
          }
        ]
      };
    },
    created() {

    },
    mixins: [mixin],
    methods: {
      //保存
      insertDietCommons(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let $this = this;
            this.ruleForm.dietLogo = this.piclist[0].fileUrl;
            this.ruleForm.dietTypeName = this.getTypeName(this.ruleForm.dietType);
            insertDietCommon(this.ruleForm)
              .then(res => {
                if (res.data.code === 200) {
                  $this.$message({
                    type: "success",
                    message: "新增成功!"
                  });
                  $this.$router.go(-1);
                } else {
                  this.$message({type: 'error', message: res.data.msg});
                }
              }).catch();
          }
          ;
        });
      },
      getTypeName(typeId) {
        let typeName = '';
        this.foodTypeList.forEach((item) => {
          if (item.id === typeId) {
            typeName = item.value
          }
        });
        return typeName;
      }
    }
  };
</script>
<style>
  .recipesadd .upload-file-item img {
    width: 80px !important;
    height: 80px !important;
    margin: 0;
    border: 1px dashed #409EFF;
    box-sizing: border-box;
    margin: 0 !important;
  }

  .recipesadd .upload-block-container .upload-file-item {
    height: 80px;
  }

  .recipesadd .upload-file-item .file-name {
    display: none;
  }
</style>
<style lang="scss" scoped>
  .recipesadd {
    padding: 12px;

    * {
      box-sizing: border-box;
    }

    .top {
      border-bottom: 1px solid #e7eaec;
      padding-bottom: 10px;
    }

    .subject {
      padding-top: 10px;
      overflow: auto;

      .body {
        width: 810px;
        margin: 0 auto;

        .el-select {
          width: 100%;
        }

        .img-b-box {
          position: absolute;
          bottom: 1px;
          left: 0px;
          width: 80px;
          text-align: center;
          color: #fff;
          height: 24px;
          line-height: 24px;
          background: rgba(0, 0, 0, 0.5);
        }

        .el-icon-circle-plus-outline {
          font-size: 20px;
          margin-left: 10px;
          color: #c0c4cc;
          cursor: pointer;
          line-height: 40px;
        }

        .el-icon-circle-plus-outline:hover {
          color: #409EFF;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/foodSetting/recipesadd.vue